<template>
  <AppSection id="timesheets" type="page" :title="$t($getConst.pages.timesheet.edit_timesheet)">
    <TimesheetForm :timesheet-to-edit-id="timesheet_id"></TimesheetForm>
  </AppSection>
</template>

<script>
  import TimesheetForm from "../TimesheetForm";
  import AppSection from "../../../components/common/sections/AppSection";

  export default {
    name: "index",
    components: {AppSection, TimesheetForm},
    data() {
      return {
        timesheet_id: this.$route.params.id,
        timesheet: null,
        is_loading: false
      }
    }
  }
</script>

<style scoped>

</style>
